import { render, staticRenderFns } from "./BaseDocumentationStatus.vue?vue&type=template&id=0184857c"
import script from "./BaseDocumentationStatus.vue?vue&type=script&lang=js"
export * from "./BaseDocumentationStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports